(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hola-coffee-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hola-roast-filter')) {
  customElements.define('hola-roast-filter', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const controls = this.querySelector('[data-filter-controls]');
      const buttons = [...this.querySelectorAll('[data-roast-filter]')];
      const cards = [...this.querySelectorAll('[data-coffee-roast]')];
      const status = this.querySelector('[data-filter-status]');
      if (!controls || !cards.length) return;
      controls.hidden = false;
      buttons.forEach(button => button.addEventListener('click', () => {
        const active = button.dataset.roastFilter;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        let count = 0;
        cards.forEach(card => {
          card.hidden = active !== 'all' && card.dataset.coffeeRoast !== active;
          if (!card.hidden) count += 1;
        });
        if (status) status.textContent = count === 1 && status.dataset.resultOne ? status.dataset.resultOne : status.dataset.resultLabel.replace('[count]', String(count));
      }));
    }
  });
}
if (!customElements.get('hola-bean-subscription')) {
  customElements.define('hola-bean-subscription', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const source = this.querySelector('[data-subscription-data]');
      if (!source) return;
      try {
        this.products = JSON.parse(source.textContent);
        if (!Array.isArray(this.products) || this.products.some(product => !Array.isArray(product.variants) || !Array.isArray(product.plans) || product.variants.some(variant => !Array.isArray(variant.allocations)))) return;
      } catch (_) {
        return;
      }
      this.initialized = true;
      this.coffee = this.querySelector('[data-subscription-coffee]');
      this.size = this.querySelector('[data-subscription-size]');
      this.grind = this.querySelector('[data-subscription-grind]');
      this.review = this.querySelector('[data-subscription-review]');
      this.add = this.querySelector('[data-subscription-add]');
      this.addLabel = this.querySelector('[data-subscription-add-label]');
      this.error = this.querySelector('[data-subscription-error]');
      this.status = this.querySelector('[data-subscription-status]');
      this.priceRow = this.querySelector('[data-subscription-price-row]');
      const controls = this.querySelector('[data-subscription-controls]');
      if (!this.coffee || !this.size || !this.grind || !this.review || !this.add || !this.addLabel || !this.error || !this.status || !this.priceRow || !controls) return;
      this.review.addEventListener('click', event => {
        if (this.review.getAttribute('aria-disabled') === 'true') event.preventDefault();
      });
      this.add.addEventListener('click', event => this.addToCart(event));
      if (!this.products.length) {
        this.disable();
        return;
      }
      controls.disabled = false;
      this.querySelector('[data-subscription-fallback]').hidden = true;
      controls.addEventListener('change', () => {
        this.error.hidden = true;
        this.error.textContent = '';
        this.update();
      });
      this.update();
    }
    normalized(value) {
      return String(value || '').toLowerCase().trim().replace(/\s+/g, ' ');
    }
    findGrind(variant) {
      const labels = [variant.title, ...(variant.options || [])].map(value => this.normalized(value));
      if (labels.some(label => label === 'whole bean' || label === 'whole beans')) return 'whole';
      if (labels.some(label => label === 'ground for drip' || label === 'drip ground')) return 'drip';
      if (labels.some(label => label === 'ground for espresso' || label === 'espresso ground')) return 'espresso';
      return null;
    }
    planMatches(plan, frequency) {
      if (!plan.recurring) return false;
      const labels = [plan.name, ...(plan.options || [])].map(value => this.normalized(value));
      return labels.some(label => label === `every ${frequency} weeks` || label === `${frequency} weeks`);
    }
    disable() {
      this.activeSelection = null;
      this.add.disabled = true;
      this.addLabel.textContent = this.busy ? this.dataset.loadingLabel : this.dataset.unavailableLabel;
      this.review.removeAttribute('href');
      this.review.setAttribute('aria-disabled', 'true');
      this.review.setAttribute('tabindex', '-1');
      this.priceRow.hidden = true;
      this.status.textContent = this.dataset.unavailable;
      this.status.hidden = false;
    }
    update() {
      const family = this.coffee.value;
      const product = this.products.find(item => item.family === family && item.size === this.size.value);
      this.querySelectorAll('[data-subscription-image]').forEach(image => {
        image.hidden = !product?.id || image.dataset.subscriptionImage !== String(product.id);
      });
      const frequencyControl = this.querySelector('[data-subscription-frequency]:checked');
      if (!frequencyControl) return this.disable();
      const frequency = frequencyControl.value;
      this.querySelectorAll('[data-subscription-notes]').forEach(notes => {
        notes.hidden = notes.dataset.subscriptionNotes !== family;
      });
      this.querySelector('[data-subscription-summary]').textContent = [
        this.coffee.selectedOptions[0].dataset.coffeeName,
        this.size.selectedOptions[0].textContent,
        this.grind.selectedOptions[0].textContent
      ].join(' · ');
      this.querySelector('[data-subscription-rhythm]').textContent = frequencyControl.nextElementSibling.textContent;
      const variant = product?.variants.find(item => this.findGrind(item) === this.grind.value);
      const plan = product?.plans.find(item => this.planMatches(item, frequency) && variant?.allocations.some(allocation => allocation.id === item.id));
      const allocation = variant?.allocations.find(item => item.id === plan?.id);
      if (!product || !variant?.available || !plan || !allocation || !/^\d+$/.test(String(variant.id)) || !/^\d+$/.test(String(plan.id))) return this.disable();
      let target;
      try {
        target = new URL(product.url, window.location.origin);
      } catch (_) {
        return this.disable();
      }
      if (target.origin !== window.location.origin || !target.pathname.includes('/products/')) return this.disable();
      target.searchParams.set('variant', variant.id);
      target.searchParams.set('selling_plan', plan.id);
      this.activeSelection = { variant, plan };
      this.add.disabled = Boolean(this.busy);
      this.addLabel.textContent = this.busy ? this.dataset.loadingLabel : this.dataset.addLabel;
      this.review.href = target.pathname + target.search + target.hash;
      this.review.removeAttribute('aria-disabled');
      this.review.removeAttribute('tabindex');
      this.querySelector('[data-subscription-price]').textContent = allocation.price;
      const compare = this.querySelector('[data-subscription-compare]');
      compare.textContent = allocation.comparePrice;
      compare.hidden = !allocation.discounted;
      this.priceRow.hidden = false;
      this.status.hidden = true;
      this.status.textContent = '';
    }
    async addToCart(event) {
      event.preventDefault();
      if (this.busy) return;
      this.update();
      const selection = this.activeSelection;
      if (!selection || this.add.disabled) return;
      const { variant, plan } = selection;
      this.busy = true;
      this.error.hidden = true;
      this.error.textContent = '';
      this.add.setAttribute('aria-busy', 'true');
      this.update();
      let added = false;
      const goToCart = () => location.assign(window.routes?.cart_url || '/cart');
      try {
        const data = new FormData();
        data.set('id', variant.id);
        data.set('selling_plan', plan.id);
        data.set('quantity', '1');
        const candidate = document.querySelector('cart-drawer');
        const cart = candidate && typeof candidate.getSectionsToRender === 'function' && typeof candidate.setActiveElement === 'function' && typeof candidate.renderContents === 'function' ? candidate : null;
        const sections = cart ? cart.getSectionsToRender().map(section => section.id) : [];
        if (cart) {
          data.set('sections', sections.join(','));
          data.set('sections_url', location.pathname);
          cart.setActiveElement(this.add);
        }
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        let result;
        try {
          result = await response.json();
        } catch (_) {
          if (response.ok) {
            added = true;
            goToCart();
            return;
          }
          throw new Error(this.dataset.errorLabel);
        }
        if (!response.ok || result?.status) throw new Error(result?.description || this.dataset.errorLabel);
        added = true;
        if (cart && result?.sections && sections.every(id => typeof result.sections[id] === 'string')) {
          cart.classList.remove('is-empty');
          await cart.renderContents(result);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hola-subscription', productVariantId: variant.id, cartData: result });
          }
        } else {
          goToCart();
        }
      } catch (error) {
        if (added) {
          goToCart();
        } else {
          this.error.textContent = error.message || this.dataset.errorLabel;
          this.error.hidden = false;
        }
      } finally {
        this.busy = false;
        this.add.removeAttribute('aria-busy');
        this.update();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hola-header"]) return;
  try {
    
  if (!customElements.get('hola-navigation')) {
    customElements.define('hola-navigation', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.dialog = this.querySelector('.hola-menu-drawer');
        this.trigger = this.querySelector('[data-hola-menu-open]');
        const fallback = this.querySelector('[data-hola-menu-fallback]');
        this.updateCurrent = () => {
          const current = new URL(window.location.href);
          this.querySelectorAll('.hola-nav-link').forEach(link => {
            const target = new URL(link.href, current);
            const view = target.searchParams.get('view');
            const sameView = !view || view === this.dataset.templateSuffix;
            const sameHash = !target.hash || target.hash === current.hash;
            const active = target.origin === current.origin && target.pathname === current.pathname && sameView && sameHash;
            if (active) link.setAttribute('aria-current', 'page');
            else link.removeAttribute('aria-current');
          });
        };
        this.updateCurrent();
        window.addEventListener('hashchange', this.updateCurrent, options);
        if (!this.dialog || !this.trigger || typeof this.dialog.showModal !== 'function') return;
        if (fallback) fallback.hidden = true;
        this.trigger.hidden = false;
        this.trigger.addEventListener('click', () => {
          if (this.dialog.open) return;
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          document.body.classList.add('hola-menu-open');
        }, options);
        this.querySelector('[data-hola-menu-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          document.body.classList.remove('hola-menu-open');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus();
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('a')) this.dialog.close();
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        window.addEventListener('resize', () => {
          if (window.innerWidth > 700 && this.dialog.open) this.dialog.close();
        }, options);
      }
      disconnectedCallback() {
        if (this.dialog?.open) this.dialog.close();
        document.body.classList.remove('hola-menu-open');
        this.abort?.abort();
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hola-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hola-brand-band')) {
    customElements.define('hola-brand-band', class extends HTMLElement {
      connectedCallback() {
        this.control = this.querySelector('.hola-home__band-control');
        if (!this.control || this.handleToggle) return;
        this.handleToggle = () => {
          const paused = this.dataset.paused !== 'true';
          this.dataset.paused = String(paused);
          this.control.setAttribute('aria-label', paused ? this.control.dataset.resumeLabel : this.control.dataset.pauseLabel);
          this.control.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
          this.control.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        };
        this.control.addEventListener('click', this.handleToggle);
        this.dataset.enhanced = 'true';
        this.control.hidden = false;
      }
      disconnectedCallback() {
        if (this.control && this.handleToggle) this.control.removeEventListener('click', this.handleToggle);
        this.handleToggle = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hola-locals-waitlist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hola-locals-waitlist')) {
    customElements.define('hola-locals-waitlist', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.form = this.querySelector('form');
        this.fieldset = this.querySelector('fieldset');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.error = this.querySelector('[role="alert"]');
        this.buttonLabel = this.button.textContent;
        this.phone = this.form.elements.phone_number;
        this.accepted = { email: false, sms: false };
        this.uncertain = { email: false, sms: false };
        this.results = {};
        this.form.addEventListener('submit', (event) => this.subscribe(event));
        ['input', 'change'].forEach((type) => this.form.addEventListener(type, () => this.clearValidation()));
        this.clearValidation();
        this.fieldset.disabled = false;
      }

      clearValidation() {
        const fields = this.form.elements;
        [fields.first_name, fields.email, fields.email_consent, fields.sms_consent, this.phone].forEach((field) => {
          field.setCustomValidity('');
          field.removeAttribute('aria-invalid');
        });
        this.phone.required = this.attempt ? this.attempt.sms && !this.accepted.sms : fields.sms_consent.checked;
      }

      invalid(field, message) {
        field.setCustomValidity(message);
        field.setAttribute('aria-invalid', 'true');
        this.error.textContent = message;
        field.reportValidity();
        field.focus();
        return false;
      }

      normalizedPhone() {
        const raw = this.phone.value.trim();
        if (!/^\+?[\d\s().-]+$/.test(raw)) return null;
        let digits = raw.replace(/\D/g, '');
        if (raw.startsWith('+') && (digits.length !== 11 || !digits.startsWith('1'))) return null;
        if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
        if (digits.length !== 10) return null;
        const patterns = {"US": "983[2-57-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[02469]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-3]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[02589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-2478]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}", "CA": "(?:2(?:04|[23]6|[48]9|5[07]|[67]3)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}"};
        const pattern = patterns[this.form.elements.phone_country.value];
        if (!pattern || !new RegExp('^(?:' + pattern + ')$').test(digits)) return null;
        if (digits.slice(3, 6) === '555' && /^01\d\d$/.test(digits.slice(6))) return null;
        return '+1' + digits;
      }

      async requestSubscription(channel, identity, phone) {
        const attributes = {
          email: identity.email,
          first_name: identity.firstName,
          subscriptions: { [channel]: { marketing: { consent: 'SUBSCRIBED' } } }
        };
        if (channel === 'sms') attributes.phone_number = phone;
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          return await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UFDqDt', {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
            credentials: 'omit',
            body: JSON.stringify({ data: {
              type: 'subscription',
              attributes: {
                custom_source: 'locals. compact waitlist: explicit ' + (channel === 'sms' ? 'SMS' : 'email') + ' consent for membership updates and occasional Hola Coffee offers',
                profile: { data: { type: 'profile', attributes } }
              },
              relationships: { list: { data: { type: 'list', id: channel === 'sms' ? 'RhdtaU' : 'YxncZ5' } } }
            } }),
            signal: controller.signal
          });
        } finally {
          clearTimeout(timer);
        }
      }

      acceptedMessage() {
        return [this.accepted.email ? this.dataset.emailSuccess : '', this.accepted.sms ? this.dataset.smsSuccess : ''].filter(Boolean).join(' ');
      }

      lockIdentity() {
        const fields = this.form.elements;
        fields.first_name.value = this.attempt.identity.firstName;
        fields.email.value = this.attempt.identity.email;
        fields.first_name.readOnly = true;
        fields.email.readOnly = true;
        fields.email_consent.checked = this.attempt.email;
        fields.sms_consent.checked = this.attempt.sms;
        fields.email_consent.disabled = true;
        fields.sms_consent.disabled = true;
        const lockPhone = this.accepted.sms || this.uncertain.sms;
        this.phone.readOnly = !!lockPhone;
        fields.phone_country.disabled = !!lockPhone;
        if (lockPhone) {
          this.phone.value = this.attempt.phone;
          fields.phone_country.value = this.attempt.country;
        }
      }

      async subscribe(event) {
        event.preventDefault();
        if (this.pending || this.complete) return;
        this.clearValidation();
        this.error.textContent = '';
        const fields = this.form.elements;
        const wantsEmail = this.attempt ? this.attempt.email : fields.email_consent.checked;
        const wantsSms = this.attempt ? this.attempt.sms : fields.sms_consent.checked;
        const identity = this.attempt ? this.attempt.identity : {
          firstName: fields.first_name.value.trim(), email: fields.email.value.trim()
        };
        if (!identity.firstName) return this.invalid(fields.first_name, this.dataset.nameError);
        if (!identity.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(identity.email)) return this.invalid(fields.email, this.dataset.emailInvalid);
        if (!wantsEmail && !wantsSms) {
          fields.sms_consent.setAttribute('aria-invalid', 'true');
          return this.invalid(fields.email_consent, this.dataset.channelError);
        }
        let phone = this.attempt && this.attempt.phone;
        if (wantsSms && !this.accepted.sms) {
          phone = this.uncertain.sms ? this.attempt.phone : this.normalizedPhone();
          if (!phone) return this.invalid(this.phone, this.dataset.phoneError);
        }
        if (!this.form.reportValidity()) return;
        if (!this.attempt) this.attempt = { email: wantsEmail, sms: wantsSms, identity, phone, country: fields.phone_country.value };
        else if (wantsSms && !this.accepted.sms && !this.uncertain.sms) {
          this.attempt.phone = phone;
          this.attempt.country = fields.phone_country.value;
        }
        this.pending = true;
        this.fieldset.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.pending;
        this.status.textContent = [this.acceptedMessage(), this.dataset.pending].filter(Boolean).join(' ');
        const errors = [];
        try {
          for (const channel of ['email', 'sms']) {
            if (!this.attempt[channel] || this.accepted[channel]) continue;
            let result = 'uncertain';
            try {
              const response = await this.requestSubscription(channel, this.attempt.identity, this.attempt.phone);
              const partialFailure = response.headers.get('X-Klaviyo-Partial-Failure');
              if (response.status === 202 && !partialFailure) {
                this.accepted[channel] = true;
                result = 'accepted';
              } else if (response.status === 429) result = 'rateLimit';
              else if (response.status >= 400 && response.status < 500) result = 'error';
            } catch (error) {
              result = 'uncertain';
            }
            if (result === 'uncertain') this.uncertain[channel] = true;
            if (result !== 'accepted' && this.uncertain[channel]) result = 'uncertain';
            this.results[channel] = result;
            if (result !== 'accepted') {
              errors.push(this.dataset[channel + (result === 'uncertain' ? 'Unknown' : result === 'rateLimit' ? 'RateLimit' : 'Error')]);
            }
            this.status.textContent = this.acceptedMessage();
          }
          this.complete = (!this.attempt.email || this.accepted.email) && (!this.attempt.sms || this.accepted.sms);
          this.error.textContent = errors.join(' ');
          if (this.complete) {
            this.form.hidden = true;
            this.status.focus();
          }
        } finally {
          this.pending = false;
          this.form.removeAttribute('aria-busy');
          if (!this.complete) {
            const preserve = this.accepted.email || this.accepted.sms || this.uncertain.email || this.uncertain.sms;
            if (preserve) this.lockIdentity();
            else this.attempt = null;
            this.fieldset.disabled = false;
            this.button.textContent = this.accepted.email ? this.dataset.smsRetry : this.accepted.sms ? this.dataset.emailRetry : this.dataset.retry;
            this.error.focus();
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
